import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import React from 'react'
import { useTranslation } from '../../../../../shared/language';

const GuideEInvoiceSuspensionRequest = ({ visible, setVisible }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      header={t('common.pauseInvoiceGuideTitle')}
      visible={visible}
      onHide={() => setVisible(false)}
      style={{ width: '600px' }}
      footer={() => (
        <div className='flex justify-content-end'>
          <Button label={t('common.close')} onClick={() => setVisible(false)} className='p-button-sm' />
        </div>
      )}
    >
      <div>
        <p>
          <span className='font-bold'>{t('common.pauseInvoiceGuideIntro')}</span>
          <br />
          {t('common.pauseInvoiceGuideReason')}
        </p>
        <div style={{ background: '#E7F3FF' }} className='px-4 py-2 border-round-lg mb-2'>
          <p className='font-bold text-xl mb-2' style={{ fontStyle: 'italic' }}>
            {t('common.guideNote')}:
          </p>
          <ul style={{ margin: 0, paddingLeft: '20px', fontStyle: 'italic' }}>
            <li className='mb-2'>
              {t('common.pauseInvoiceGuideDateRule')}
              <ul style={{ marginTop: '4px', paddingLeft: '20px', listStyleType: 'none' }}>
                <li>- {t('common.pauseInvoiceGuideDateRequired')}</li>
                <li>- {t('common.pauseInvoiceGuideDateAfterDeclaration')}</li>
                <li>- {t('common.pauseInvoiceGuideDateOrder')}</li>
              </ul>
            </li>
            <li className='mb-2'>
              {t('common.pauseInvoiceGuideMultipleProviders')}
            </li>
            <li>
              {t('common.pauseInvoiceGuideSpecificCertificate')}
            </li>
          </ul>
        </div>
      </div>
    </Dialog>
  )
}

export default GuideEInvoiceSuspensionRequest
